import { memo } from 'react'
import cn from 'classnames'

import type { ScreenBackgroundProps } from './types'

import styles from './ScreenBackground.module.scss'

const STAR_COUNT = 5

/**
 * Фоновые пятна экрана по спеке 01 §1/§2.3. Максимум два цвета свечения.
 * На главном фон статичный — звёзды выключаются через showStars={false}.
 */
export const ScreenBackground = memo(function ScreenBackground(props: ScreenBackgroundProps) {
  const { variant = 'HOME', showStars = true } = props

  return (
    <div className={cn(styles.root, styles[`variant_${variant}`])} aria-hidden='true'>
      <div className={styles.spotTop} />
      <div className={styles.spotBottom} />
      {showStars &&
        Array.from({ length: STAR_COUNT }, (_, index) => (
          <span key={index} className={styles.star} />
        ))}
    </div>
  )
})
